//google translation
function googleTranslateElementInit() {
    new google.translate.TranslateElement({ pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.SIMPLE, multilanguagePage: true, autoDisplay: false }, 'google_translate_element');
}

//read speaker plugin
window.rsConf = { general: { usePost: true } };
// $('.vocie-me').click(function(){$('.rsbtn_play').click();$('#readspeaker_button1').show();$('#readspeaker_button1').css('text-align','center');$('#readspeaker_button1').css('width','auto');$('#readspeaker_button1').css('display','inline-block');})
